import React from 'react';

import Field from './Field';

const Input = ({ maxLength, max, minLength, inputMode, defaultValue, ...props }) => {
  return (
    <Field defaultValue={defaultValue} {...props}>
      <input maxLength={maxLength} max={max} minLength={minLength} inputMode={inputMode} />
    </Field>
  );
};

Input.propTypes = {};

Input.defaultProps = {};

export default Input;
